import React from "react";
import Tabs from "@components/Tabs";
import Div from "@components/Div";

const TabMenu = (props) => {
  return (
    <Div position="fixed" bottom={0} display="flex" width={1}>
      <Tabs {...props} isBottomMenu className="bottom-tab-menu" />
    </Div>
  );
};

export default TabMenu;
